export enum CaptionModeEnum {
  None = 0,
  Open = 1,
  Closed = 2,
}

export type CaptionMode = CaptionModeEnum.None | CaptionModeEnum.Open | CaptionModeEnum.Closed;
